import axios from 'axios';
import { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { loginState } from '../states/loginState';

type ExchangeAPIResponse = {
  success: boolean;
  memberNo?: string;
  userId?: string;
};

// 自動ログイン用の単回使用チケットを使ってログインするメソッド、
// エラーメッセージを返すフック
const useExchangeTicket = () => {
  const setIsLogin = useSetRecoilState(loginState);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const exchangeTicket = async (ticket: string) => {
    try {
      const { data } = await axios.post<ExchangeAPIResponse>(
        `${process.env.REACT_APP_PUBLIC_API_URL}/auth/exchange`,
        { ticket },
        {
          headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,
          },
          withCredentials: true,
          validateStatus: (status) => {
            // ステータスコードが500番台のときはcatchに入る
            return status < 500;
          },
        },
      );

      if (data.success) {
        setIsLogin(true);
        return true;
      } else {
        // 期限切れ・使用済み(401)も形式不正(400)もここに入る
        setErrorMessage(
          '自動ログインに失敗しました。IDとパスワードでログインしてください',
        );
        return false;
      }
    } catch (err) {
      setErrorMessage(
        '自動ログインに失敗しました。IDとパスワードでログインしてください',
      );
      return false;
    }
  };

  return { exchangeTicket, errorMessage };
};

export default useExchangeTicket;
